import { useIdentifiedContext } from "../contexts/IdentifiedContext";

export const useIsIdentityLng = () => {
  const { identity } = useIdentifiedContext();
  return identity.departmentCode.toLowerCase().includes("lng");
};
